import React, { useContext } from 'react';
import styled from 'styled-components';
import ThemeContext from '../../../theme/ThemeContext';

const StyledFieldLabelElement = styled.label`
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => props.theme.fontColorPrimary};
  margin-bottom: 6px;
`;

export const StyledFieldLabel = (props) => {

  const theme = useContext(ThemeContext);
  const { children } = props;

  return (
    <StyledFieldLabelElement theme={theme} {...props}>
      {children}
    </StyledFieldLabelElement>
  );
};

export const StyledErrorMessage = styled.div`
  color: ${(props) => props.theme.dangerColor};
  font-size: 12px;
  margin-top: 4px;
  margin-left: 3px;
`;

/**
 * Field Settings Wrapper Styles
 *
 * - Top and Bottom Space: 12px;
 * - Left and Right Space: 12px;
 */
export const StyledFieldWrapper = styled.div`
  box-sizing: border-box;
  margin: 0px 12px 12px 12px;
`;

export const StyledAccordionFieldWrapper = styled.div`
  /**
   * Accordion already applies right and left space internally
   */
  box-sizing: border-box;
  margin-bottom: 12px;
`;

export const StyledButtonGroupWrapper = styled.div`
  /**
   * Button groups already have 8px marign on the bottom
   * of each button. So we only add 4px to get to 12px.
   */
  margin: 0px 12px 4px 12px;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 12px;
  gap: 8px;
`;

const DividerLineElement = styled.div`
  width: 100%;
  margin-bottom: 12px;
  border-bottom: 1px solid ${(props) => props.theme.borderColor};
`;

export const DividerLine = (props) => {

  const theme = useContext(ThemeContext);
  const { children } = props;

  return (
    <DividerLineElement theme={theme} {...props}>
      {children}
    </DividerLineElement>
  );

};

const StyledAddonAfterElement = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => props.theme.fontColorSecondary};
  svg {
    color: ${(props) => props.theme.fontColorSecondary};
  }
`;

export const StyledAddonAfter = (props) => {

  const theme = useContext(ThemeContext);
  const { children } = props;

  return (
    <StyledAddonAfterElement theme={theme} {...props}>
      {children}
    </StyledAddonAfterElement>
  );
};

const StyledAddonBeforeElement = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.fontColorPrimary};
  svg {
    color: ${(props) => props.theme.fontColorPrimary};
  }
`;

export const StyledAddonBefore = (props) => {

  const theme = useContext(ThemeContext);
  const { children } = props;

  return (
    <StyledAddonBeforeElement theme={theme} {...props}>
      {children}
    </StyledAddonBeforeElement>
  );
};
